@if (data$ | async; as data) {
  @if (data | hasContent) {
    <p-accordion [multiple]="true">
      @for (scorecard of data.qualifiedScorecard; track scorecard.scorecardId) {
        <a [routerLink]="'../agent-performance/' + scorecard.scorecardId" queryParamsHandling="preserve">
          <cv-scorecard-preview [scorecard]="scorecard" />
        </a>
      }

      @if (data.conversationDetails.tags.errorResponse?.status === EHttpErrorStatus.serverIssue) {
        <cv-alert class="mb-20">Oops! We encountered a problem retrieving the conversation tags.</cv-alert>
      } @else if (data.conversationDetails.tags.data?.length) {
        <cv-tags [tags]="data.conversationDetails.tags.data"></cv-tags>
      }
      @if (data.conversationDetails.contactDetails.errorResponse?.status === EHttpErrorStatus.serverIssue) {
        <cv-alert class="mb-20">Oops! We encountered a problem retrieving the contact details.</cv-alert>
      } @else if (data.conversationDetails.contactDetails.data) {
        <cv-contact-details [data]="data.conversationDetails.contactDetails.data" />
      }
      @if (data.conversationDetails.appointmentDetails.errorResponse?.status === EHttpErrorStatus.serverIssue) {
        <cv-alert class="mb-20">Oops! We encountered a problem retrieving appointment details.</cv-alert>
      } @else if (data.conversationDetails.appointmentDetails.data) {
        <cv-appointment-details [data]="data.conversationDetails.appointmentDetails.data" />
      }
      @if (data.conversationDetails.leasingPreferences.errorResponse?.status === EHttpErrorStatus.serverIssue) {
        <cv-alert class="mb-20">Oops! We encountered a problem retrieving the leasing preferences.</cv-alert>
      } @else if (data.conversationDetails.leasingPreferences.data) {
        <cv-leasing-preferences [data]="data.conversationDetails.leasingPreferences.data" />
      }
      @if (data.conversationDetails.campaignDetails.errorResponse?.status === EHttpErrorStatus.serverIssue) {
        <cv-alert class="mb-20">Oops! We encountered a problem retrieving the campaign details.</cv-alert>
      } @else if (data.conversationDetails.campaignDetails.data) {
        <cv-campaign-details [data]="data.conversationDetails.campaignDetails.data"></cv-campaign-details>
      }
      @if (data.conversationDetails.conversationDetails.errorResponse?.status === EHttpErrorStatus.serverIssue) {
        <cv-alert class="mb-20">Oops! We encountered a problem retrieving the conversation details.</cv-alert>
      } @else if (data.conversationDetails.conversationDetails.data) {
        <cv-conversation-details [data]="data.conversationDetails.conversationDetails.data" />
      }

      @if (data.hasACEInsightsAdminClaim) {
        <cv-reprocessing-tools />
      }

      @for (scorecard of data.disqualifiedScorecard; track scorecard.scorecardId) {
        <a [routerLink]="'../agent-performance/' + scorecard.scorecardId" queryParamsHandling="preserve">
          <cv-scorecard-preview [scorecard]="scorecard" />
        </a>
      }
    </p-accordion>
  } @else {
    <p-skeleton height="4rem" styleClass="mb-15" borderRadius="8px" />
    <p-skeleton height="2rem" width="10rem" styleClass="mb-5" />
    <p-skeleton height="12rem" styleClass="mb-15" borderRadius="8px" />
    <p-skeleton height="2rem" width="10rem" styleClass="mb-5" />
    <p-skeleton height="10rem" styleClass="mb-15" borderRadius="8px" />
    <p-skeleton height="2rem" width="10rem" styleClass="mb-5" />
    <p-skeleton height="12rem" styleClass="mb-15" borderRadius="8px" />
    <p-skeleton height="2rem" width="10rem" styleClass="mb-5" />
    <p-skeleton height="8rem" styleClass="mb-15" borderRadius="8px" />
    <p-skeleton height="2rem" width="10rem" styleClass="mb-5" />
    <p-skeleton height="10rem" styleClass="mb-15" borderRadius="8px" />
  }
}
